<template>
	<div class="dtcard">
		<el-breadcrumb v-if='isShowBd' separator="/" style="font-size: 14px;">
			<el-breadcrumb-item :key='item.path' v-for='item in currentRoute' :to="item.path">{{item.name}}
			</el-breadcrumb-item>
		</el-breadcrumb>
		<el-row class='dcttrow'>
			<el-col :span='12'>
				<label class="dtctlb" style="width: 100%;">{{title? title:$route.name}}</label>
			</el-col>
			<el-col :span='12' style="text-align: right;">
				<el-button v-show='this.config.testplay' @click="clickTestplay" size='small' type='primary'>{{ $t("terminal.test_broadcast") }}
				</el-button>
				<el-button v-show='this.config.epswitch' @click="clickEPSwitch" size='small' type='primary'>{{eptt}}
				</el-button>
				<el-button v-show='this.config.edit' @click="edit" size='small' type='primary'>{{ $t("app_edit") }}</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<div class='dcrow' v-for='item in rd1' :key="item.tt">
					<label class="dtttlb">{{item.tt}}：</label><label class="dtctlb">{{item.ct}}</label>
				</div>
			</el-col>
			<el-col :span="8">
				<div class='dcrow' v-for='item in rd2' :key="item.tt">
					<label class="dtttlb">{{item.tt}}：</label><label class="dtctlb">{{item.ct}}</label>
				</div>
			</el-col>
			<el-col :span="8">
				<el-row class="dcrow3">
					<el-col :offset="6" :span='9' style="">
						<label>{{rd3.length > 1?rd3[1].tt:''}}&nbsp;</label>
						<div>{{rd3.length > 1?rd3[1].ct:''}}&nbsp;</div>
					</el-col>
					<el-col :offset="rd3.length==1?15:0" :span='9'>
						<label>{{rd3.length > 0?rd3[0].tt:''}}&nbsp;</label>
						<div>{{rd3.length > 0?rd3[0].ct:''}}&nbsp;</div>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isBd: true,
				// rd3: [
				//   {tt: '累计订单', ct: '186笔'},
				//   {tt: '累计收款', ct: '￥568.08'}
				// ]
				title: '',
				rd1: {},
				rd2: {},
				rd3: {},
				epIsDv: true
			}
		},
		computed: {
			eptt() {
				return this.epIsDv ? this.$t('terminal.broadcast_record') : this.$t('terminal.device_list')
			},
			isShowBd() {
				return this.isBd
			},
			currentRoute() {
				var arr = this.$route.matched
				arr.shift()
				return arr
			}
		},
		props: ['config'],
		watch: {
			config(n) {
				this.title = n.title
				this.rd1 = n.rd1
				this.rd2 = n.rd2
				this.rd3 = n.rd3
				this.isBd = n.hidebd ? false : true
			}
		},
		methods: {
			clickTestplay() {
				if (this.config) {
					if (this.config.testplay) {
						this.config.testplay()
					}
				}
			},
			clickEPSwitch() {
				this.epIsDv = !this.epIsDv
				if (this.config) {
					if (this.config.epswitch) {
						this.config.epswitch(this.epIsDv)
					}
				}
			},
			edit() {
				if (this.config) {
					if (this.config.edit) {
						this.config.edit()
					}
				}
			}
		},
		mounted() {

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.dtcard {
		background: white;
		padding: 16px 32px 24px 32px;
	}

	.dcttrow {
		margin: 16px 0 12px 0;
		height: 32px;
		line-height: 32px;
	}

	.dcttrow label {
		font-size: 20px;
	}

	.dcrow {
		margin-bottom: 8px;
		height: 22px;
		line-height: 22px;
		overflow: hidden;
	}

	.dcrow label:nth-child(1) {
		color: rgba(0, 0, 0, 0.85);
	}

	.dcrow label:nth-child(2) {
		color: rgba(0, 0, 0, 0.65);
	}

	.dcrow3 {
		text-align: right;
	}

	.dcrow3 div {
		font-size: 20px;
		color: rgba(0, 0, 0, 0.85);
	}

	.dcrow3 label {
		color: rgba(0, 0, 0, 0.45);
		font-size: 14px
	}

	.dtttlb {
		display: line-block;
		float: left;
	}

	.dtctlb {
		display: inline-block;
		width: 50%;
		/* background: red; */
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
</style>
